import { useQuery } from "react-query";
import axios from "axios";
import { HeritageAuthStatus } from "../types/heritage-auth";
import { useCompanyFeature } from "./useCompanyFeature";

const fetchHeritageAuthStatus = async (): Promise<HeritageAuthStatus> => {
  const response = await axios.get<HeritageAuthStatus>(
    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/heritage/auth/status`
  );
  return response.data;
};

export const useHeritageAuthStatus = (options?: { enabled?: boolean }) => {
  // Gated on the company feature internally — the endpoint 404s when it is off.
  const heritageEnabled = useCompanyFeature("heritage");
  return useQuery<HeritageAuthStatus>(
    ["heritage-auth-status"],
    fetchHeritageAuthStatus,
    {
      enabled: heritageEnabled && options?.enabled !== false,
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000,
    }
  );
};
